<template>
  <q-page class="flex column login page-layout">
    <PageTitle :title="'Profile'" :parentPage="'Profile'" :icon="'face'" />
    <div class="q-py-lg row items-start q-gutter-md">
      <q-card flat class="content-card q-pa-md">
        <q-card-section>Email: {{ email }} </q-card-section>
      </q-card>
    </div>
  </q-page>
</template>

<script>
import { Auth } from "aws-amplify";
import PageTitle from "@/components/content/PageTitle.vue";
export default {
  name: "TheProfile",
  components: {
    PageTitle,
  },
  data() {
    return {
      user: {},
      email: {},
    };
  },
  beforeCreate() {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        this.user = user;
        this.email = user.attributes.email;
      })
      .catch(() => console.log("not signed in..."));
  },
};
</script>

<style lang="scss" >
.login {
  &__container {
    header {
      text-align: center;
      h1 {
        margin: 0 !important;
      }
    }
  }
}
</style>
